import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";

export default function VerifyReview() {
  const [searchParams] = useSearchParams();
  let token = searchParams.get("token");
const store = searchParams.get("store"); // store URL
  const [status, setStatus] = useState("Verifying your review...");

useEffect(() => {
  if (!token) {
    setStatus("❌ Missing verification token.");
    return;
  }

  const verifyReview = async () => {
    const headers = {
      "Content-Type": "application/json",
      "x-shop-url": store,
    };
    try {
      const res = await fetch(
        `${process.env.REACT_APP_REVIEW_BACKEND_URL}/api/reviews/verify?token=${token}`,
        { method: "GET", headers }
      );

      if (!res.ok) {
        const errorData = await res.json();
        setStatus(`❌ ${errorData.message || "Invalid or expired link."}`);
        return;
      }

      const data = await res.json();
      if (data.success) {
        setStatus("🎉 Thank you! Your review has been verified and published.");
      } else {
        setStatus(`❌ ${data.message || "Verification failed."}`);
      }
    } catch (err) {
      setStatus("⚠️ Server error. Please try again later.");
    }
  };

  verifyReview();
}, [token, store]);


  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-100 px-4">
      <div className="bg-white shadow-lg rounded-2xl p-8 max-w-md text-center">
        <h1 className="text-2xl font-bold mb-4">Review Verification</h1>
        <p className="text-gray-700">{status}</p>

        {status.startsWith("🎉") && (
          <a
            href="/"
            className="inline-block mt-6 px-6 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 transition"
          >
            Go Back Home
          </a>
        )}
      </div>
    </div>
  );
}
